import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type ExportState = {
  id: string;
  data: Record<string, unknown>;
  error?: unknown;
};

const initialState: ExportState = {
  id: "",
  data: {},
};

export const exportSlice = createSlice({
  name: "exporter",
  initialState,
  reducers: {
    updateRawData: (
      state,
      action: PayloadAction<{ id: string; data: Record<string, unknown> }>,
    ) => {
      state.id = action.payload.id;
      state.data = action.payload.data;
    },
    handleExporterError: (state, action: PayloadAction<unknown>) => {
      state.error = action.payload;
    },
  },
});

export const { updateRawData, handleExporterError } = exportSlice.actions;
export default exportSlice.reducer;
